import React, { useState, useEffect } from 'react';
import { FiChevronRight, FiChevronLeft } from 'react-icons/fi';
import { FaQuoteRight } from 'react-icons/fa';
import data from './data';

function App() {
  const [slides, setSlides] = useState(data);
  const [index, setIndex] = useState(0);

  useEffect(() => {
    if (index < 0) setIndex(slides.length - 1);
    if (index > slides.length - 1) setIndex(0);
  }, [index]);

  useEffect(() => {
    const interval = setInterval(() => setIndex(index + 1), 5000);
    return () => clearInterval(interval);
  }, [index]);

  return (
    <section className='section'>
      <div className='title'>
        <h2>
          <span>/</span>reviews
        </h2>
      </div>
      <section className='section-center'>
        {slides.map((slide, slideIdx) => {
          const { id, name, image, title, quote } = slide;
          let position = 'nextSlide';
          if (index === slideIdx) position = 'activeSlide';
          if (
            index - 1 === slideIdx ||
            (index === 0 && slideIdx === slides.length - 1)
          )
            position = 'lastSlide';
          return (
            <article className={position} key={id}>
              <img src={image} alt={name} className='person-img' />
              <h4>{name}</h4>
              <p className='title'>{title}</p>
              <p className='text'>{quote}</p>
              <FaQuoteRight className='icon' />
            </article>
          );
        })}
        <button className='prev' onClick={() => setIndex(index - 1)}>
          <FiChevronLeft />
        </button>
        <button className='next' onClick={() => setIndex(index + 1)}>
          <FiChevronRight />
        </button>
      </section>
    </section>
  );
}

export default App;
